import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const postMRData = async ({ data }) => {
  try {
    const response = await safetyDefaultAPI.post('mr', data);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default postMRData;
